import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { submitSiteDelete } from "./../../utils/commonComponent/delete";
import {
  fetchByTable,
  fetchQuery,
} from "./../../utils/commonComponent/fetched";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import ListView from "../../utils/commonComponent/Custom/listView";
import { getPermissions } from "../rbac/hasAccess";

const headers = ["id", "holidayName", "date", "holidayType"];

const fields = [
  { value: "holidayName", label: "Holiday Name" },
  { value: "holidayType", label: "Holiday Type" },
];

const HolidayList = (props) => {
  const navigate = useNavigate();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/master/editHoliday/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("holidayRegister", row.id);

  const [disciplineList, setHolidayList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState("");
  const [searchKey, setSearchKey] = React.useState("");
  const [searched, setSearched] = React.useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    // fetch new data from backend here
  };

  const getWhereClause = () => {
    const colMap = {
      holidayName: "holidayName",
      holidayType: "holidayType",
    };

    const colName = colMap[searchBy];
    const key = searchKey.trim();

    let whereConditions = ["status = 1"];

    if (colName && key) {
      whereConditions.push(`${colName} LIKE '%${key}%'`);
    }

    return whereConditions.length
      ? `WHERE ${whereConditions.join(" AND ")}`
      : "";
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause();

    let paginationSettings = "";
    if (rowsPerPage !== -1) {
      paginationSettings = `LIMIT ${rowsPerPage} OFFSET ${
        rowsPerPage * Number(currentPage)
      }`;
    }

    return `
    SELECT *
    FROM holidayRegister
    ${whereClause}
    ORDER BY id DESC
    ${paginationSettings};
  `;
  };

  const getCountQuery = () => {
    const whereClause = getWhereClause();

    return `
    SELECT COUNT(*) AS totalRows
    FROM holidayRegister
    ${whereClause};
  `;
  };

  const fetchData = async () => {
    try {
      const [holidayData, countResult] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
      ]);

      setHolidayList(holidayData);
      setTotalRows(countResult?.[0]?.totalRows || 0); // 👈 pagination total
    } catch (error) {
      console.error("Error fetching Holiday data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("");
    setSearchKey("");
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/master/editHoliday/0"
          label="Add Holiday"
          icon={<AddIcon fontSize="small" />}
        />
      )}
      <ListSearchSection
        title="Search Holiday"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      <ListView
        headers={headers}
        data={disciplineList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
        }}
        showCheckbox={true}
        deleteTableName={"holidayRegister"}
        moduleId={props.moduleId}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPaginationChange={handlePaginationChange}
      />
    </>
  );
};

export default HolidayList;
